<template>
    <tr
        :class="{ 'ou-bg': isOpenUniverse }"
    >
        <td v-if="canCreateGroup">
            <checkbox-input
                v-model="selected"
                name="addresses[]"
                :value="address.id"
                :disabled="disabled"
                @toggle="toggleItem"
            />
        </td>
        <td>
            <a :href="route('admin.sales-projects.addresses.show', [project, address])">
                {{ address.full_address_with_apartment_number }}
            </a>
        </td>
        <toggle-table-td-item
            v-for="column in selectedColumns"
            :key="`sales-project-addresses-tbody-${address.id}-${column.value}`"
            :model="address"
            :column="column"
            store-name="salesProjectAddressesTable"
        />
    </tr>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        props: {
            address: {
                required: true,
                type: Object,
            },
            project: {
                required: true,
                type: Object,
            },
            canCreateGroup: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                selected: false,
            };
        },
        computed: {
            disabled() {
                return this.address.group_id !== null;
            },
            ...mapGetters({
                selectedColumns: 'salesProjectAddressesTable/selectedColumns',
                shouldShowColumn: 'salesProjectAddressesTable/shouldShowColumn',
            }),
            isOpenUniverse() {
                return this.address.isOpenUniverse;
            },
        },
        created() {
            EventBus.$on('all-addresses-toggled', (toggled) => {
                if (! this.disabled) {
                    this.selected = toggled;
                    this.toggleItem();
                }
            });
        },
        methods: {
            toggleItem() {
                this.$emit('toggleAddressSelected', this.address, this.selected);
            },
        },
    };
</script>
